import { useTranslation } from 'react-i18next'
import { ReferralsList } from './components/referrals-list'

export function ReferralsPage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold" id="referrals-title">
          {t('referrals.title')}
        </h1>
        <p className="text-sm text-muted-foreground">{t('referrals.description')}</p>
      </div>
      <ReferralsList />
    </div>
  )
}
